import React, { useEffect, useState } from 'react'
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from '@coreui/react'
import moment from 'moment'
import { isEmpty } from 'lodash'

const MonthlyCalendar = ({ dates, data, onMoreClick }) => {
  let daysArr = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']
  const [calendarSlots, setCaledarSlots] = useState({
    0: <></>,
    1: <></>,
    2: <></>,
    3: <></>,
    4: <></>,
    5: <></>,
    6: <></>,
    7: <></>,
    8: <></>,
    9: <></>,
    10: <></>,
    11: <></>,
    12: <></>,
    13: <></>,
    14: <></>,
    15: <></>,
    16: <></>,
    17: <></>,
    18: <></>,
    19: <></>,
    20: <></>,
    21: <></>,
    22: <></>,
    23: <></>,
    24: <></>,
    25: <></>,
    26: <></>,
    27: <></>,
    28: <></>,
    29: <></>,
    30: <></>,
    31: <></>,
    32: <></>,
    33: <></>,
    34: <></>,
  })

  useEffect(() => {
    tempcheckDateSlot()
  }, [dates, data])

  const checkCardSlot = (date) => {
    let scheduleContentArr = data.filter(
      (dataObj) =>
        moment(date).isSame(moment(dataObj.start_time).format('D MMM yyyy')) ||
        moment(date).isSame(moment(dataObj.end_time).format('D MMM yyyy')),
    )
    return scheduleContentArr.sort((first, second) => {
      return first.start_time - second.start_time
    })
    // SORT ACCRODING TO TIME
  }
  const getTodayContent = (scheduleContentArr) => {
    return 'sadasda'
  }

  const tempcheckDateSlot = () => {
    let tempCalendarSlots = {}
    let tempDates = JSON.parse(JSON.stringify(dates))
    for (let rowIndex = 0; rowIndex < 5 && !isEmpty(tempDates); rowIndex++) {
      for (let dayIndex = 0; dayIndex < daysArr.length && !isEmpty(tempDates); dayIndex++) {
        const day = daysArr[dayIndex]

        for (let dateIndex = 0; dateIndex < tempDates.length; dateIndex++) {
          const dateofMonth = tempDates[dateIndex]
          const today = moment().format('D MMM yyyy')
          const isToday = moment(dateofMonth).isSame(today)
          if (moment(dateofMonth).format('dddd').toLowerCase() === day.toLowerCase()) {
            tempDates.shift()
            let scheduleContentArr = checkCardSlot(dateofMonth)
            tempCalendarSlots[`${rowIndex * 7 + dayIndex}`] = (
              <div className="pl-1 mt-2">
                <div className="d-flex justify-content-end align-items-center mr-2">
                  <div
                    style={{
                      fontSize: '22px',
                      fontWeight: 'bold',
                      width: '41px',
                      height: '41px',
                      background: isToday ? 'black' : 'white',
                      borderRadius: '50%',
                    }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <p style={{ color: isToday ? 'white' : 'black' }} className="mb-0">
                      {moment(dateofMonth).format('D')}
                    </p>
                  </div>
                </div>
                {!isEmpty(scheduleContentArr) && (
                  <>
                    <div
                      style={{
                        background: isToday ? 'black' : '#d6d6d6',
                        fontSize: '12px',
                        fontWeight: '500',
                        borderRadius: '6px',
                        color: isToday ? 'white' : 'black',
                      }}
                      className="p-1 mt-1 mr-4 line-clamp-1"
                    >
                      {/* {isToday && getTodayContent(scheduleContentArr)} */}
                      {isToday && scheduleContentArr[0].title}
                      {moment(dateofMonth).isAfter(today) && scheduleContentArr[0].title}
                      {moment(dateofMonth).isBefore(today) &&
                        scheduleContentArr[scheduleContentArr.length - 1].title}
                    </div>
                    <p
                      style={{
                        fontSize: '12px',
                        fontWeight: '500',
                      }}
                      className="mb-0 text-right mt-1 mr-5 cursor-pointer hover:underline"
                      onClick={() => onMoreClick(dateofMonth)}
                    >
                      {scheduleContentArr.length > 1
                        ? `+${scheduleContentArr.length - 1} More`
                        : ''}
                    </p>
                  </>
                )}
              </div>
            )
            if (!isEmpty(tempDates) && `${rowIndex * 7 + dayIndex}` === `34`) {
              rowIndex = 0
              dayIndex = -1
            }
            break
          } else {
            break
          }
        }
      }
    }

    setCaledarSlots({ ...tempCalendarSlots })
  }
  // const checkDateSlot = (datesArrIndex, day) => {
  //   console.log('datesArrIndex, day', datesArrIndex)
  //   let tempDates = dates
  //   for (let index = 0; index < tempDates.length; index++) {
  //     const dateofMonth = tempDates[index]
  //     const today = moment().format('D MMM yyyy')
  //     const isToday = moment(dateofMonth).isSame(today)
  //     if (moment(dateofMonth).format('dddd').toLowerCase() === day.toLowerCase()) {
  //       tempDates.shift()
  //       let scheduleContentArr = checkCardSlot(dateofMonth)
  //       return (
  //         <div className="pl-1 mt-2">
  //           <div className="d-flex justify-content-end align-items-center mr-2">
  //             <div
  //               style={{
  //                 fontSize: '22px',
  //                 fontWeight: 'bold',
  //                 width: '41px',
  //                 height: '41px',
  //                 background: isToday ? 'black' : 'white',
  //                 borderRadius: '50%',
  //               }}
  //               className="d-flex align-items-center justify-content-center"
  //             >
  //               <p style={{ color: isToday ? 'white' : 'black' }} className="mb-0">
  //                 {moment(dateofMonth).format('D')}
  //               </p>
  //             </div>
  //           </div>
  //           {!isEmpty(scheduleContentArr) && (
  //             <>
  //               <div
  //                 style={{
  //                   background: isToday ? 'black' : '#d6d6d6',
  //                   fontSize: '12px',
  //                   fontWeight: '500',
  //                   borderRadius: '6px',
  //                   color: isToday ? 'white' : 'black',
  //                 }}
  //                 className="p-1 mt-1 mr-4 line-clamp-1"
  //               >
  //                 {/* {isToday && getTodayContent(scheduleContentArr)} */}
  //                 {isToday && scheduleContentArr[0].title}
  //                 {moment(dateofMonth).isAfter(today) && scheduleContentArr[0].title}
  //                 {moment(dateofMonth).isBefore(today) &&
  //                   scheduleContentArr[scheduleContentArr.length - 1].title}
  //               </div>
  //               <p
  //                 style={{
  //                   fontSize: '12px',
  //                   fontWeight: '500',
  //                 }}
  //                 className="mb-0 text-right mt-1 mr-5 cursor-pointer hover:underline"
  //                 onClick={() => onMoreClick(dateofMonth)}
  //               >
  //                 {scheduleContentArr.length > 1 ? `+${scheduleContentArr.length - 1} More` : ''}
  //               </p>
  //             </>
  //           )}
  //         </div>
  //       )
  //     } else {
  //       // if () {

  //       // }
  //       return ''
  //     }
  //   }
  // }

  return (
    <CTable borderless>
      <CTableHead>
        <CTableRow style={{ textAlign: 'center' }}>
          <CTableHeaderCell
            style={{ backgroundColor: '#fff', width: '5%', zIndex: '' }}
            className=" p-0 mb-2"
          />
          {daysArr.map((val, idx) => (
            <CTableHeaderCell
              scope="col"
              key={idx}
              style={{
                backgroundColor: '#fff',
                borderLeft: '0.5px solid #7e7e7e50',
                borderRight: '0.5px solid #7e7e7e50',
              }}
              className="p-0"
            >
              <div
                className={`w-100 py-2 px-3 d-flex align-items-center justify-content-center`}
                style={{
                  height: '57px',
                  borderTop: '0.5px solid #7e7e7e50',
                  borderBottom: '0.5px solid #7e7e7e50',
                }}
              >
                <p style={{ fontSize: '16px' }} className="mb-0">
                  {/* {moment(val).format('D MMMM YYYY (dddd)')} */}
                  {val}
                </p>
              </div>
            </CTableHeaderCell>
          ))}
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {[0, 1, 2, 3, 4].map((date, rowIndex) => (
          <CTableRow className="" key={rowIndex} style={{ height: '120px' }}>
            <CTableDataCell className="p-0 position-relative" />
            {daysArr.map((day, dayIndex) => (
              <CTableDataCell
                style={{
                  borderBottom: `0.5px solid #7e7e7e50`,
                  borderTop: '0px',
                  borderLeft: '0.5px solid #7e7e7e50',
                  borderRight: '0.5px solid #7e7e7e50',
                }}
                className=" p-0 position-relative"
                key={dayIndex}
              >
                {calendarSlots[`${rowIndex * 7 + dayIndex}`]}
                {/* {checkDateSlot(rowIndex * 7 + dayIndex, day)} */}
              </CTableDataCell>
            ))}
          </CTableRow>
        ))}
      </CTableBody>
    </CTable>
  )
}

export default MonthlyCalendar
